import ProductInfo from "./ProductInfo";
import productImage from "../../../assets/images/Products/ScrumMasterDashboard.png";

function ScrumMaster() {
  return (
    <>
      <ProductInfo
        title="Scrum Master"
        primaryDescription=" Scrum Master is an agile project management tool for SharePoint/MS Teams."
        secondaryDescription="This app is entirely deployed in your SharePoint site, so
                  that you don't have to invest on additional infrastructure or
                  any third party services for the add-in to function. Users
                  don't have to worry about the data security as the add-in
                  stores all the data in the sharepoint site itself"
        features={[
          "Trendy looking dashboard graphs and charts",
          "Choose your theme for the app according to your sharepoint site's branding",
          "Email notifications",
          "FluentUI design and components which blend well with modern SharePoint UI",
          "Timesheet feature to track productivity of the resources",
          "Export resources productivity data to excel",
          "Roles and permission based data access",
          "Easy to use, self explanatory interfaces",
          "Create and manage Projects, sprints and backlog",
          "Advance search feature for tasks",
          "Interactive kanban board to easily work with sprints and backlog",
        ]}
        image={productImage}
        appsourceLink="https://appsource.microsoft.com/en-us/product/office/WA104381394?tab=Overview"
        youTubeLink="https://www.youtube.com/embed/KrgplDf-Ovc"
        pricings={[
          {
            userLimit: "Unlimited",
            price: "$199.99 USD",
            priceText: "/Month",
            secondaryText: "Billed Annually",
            paymentLink: "",
          },
          // {
          //   userLimit: "10",
          //   price: "$49 USD",
          //   priceText: "per month",
          //   secondaryText: "Billed Annually",
          //   paymentLink: "",
          // },
          // {
          //   userLimit: "100",
          //   price: "$199 USD",
          //   priceText: "per month",
          //   secondaryText: "Billed Annually",
          //   paymentLink: "",
          // },
          // {
          //   userLimit: "300",
          //   price: "$499 USD",
          //   priceText: "per month",
          //   secondaryText: "Billed Annually",
          //   paymentLink: "",
          // },
          // {
          //   userLimit: "500",
          //   price: "$999 USD",
          //   priceText: "per month",
          //   secondaryText: "Billed Annually",
          //   paymentLink: "",
          // },
          // {
          //   userLimit: "Unlimited",
          //   price: "$4999 USD",
          //   priceText: "per month",
          //   secondaryText: "Billed Annually",
          //   paymentLink: "",
          // },
        ]}
      />
    </>
  );
}

export default ScrumMaster;
